var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-custom-scrollbar',{staticClass:"scroll-area scroll-area--mb"},_vm._l((_vm.students),function(item,index){return _c('app-member-list',{key:index,attrs:{"member":item}})}),1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }